import {
  addTag,
  closeSurveyModal,
  fetchChannelData,
  fetchEpisodeData,
  leaveThePage,
  removeTag,
  selectPostAccount,
  sending,
  sendingFailed,
  updateAnonymousUserProfileImage,
  updateTitle,
} from "../../../actions/pages/editor/editorActionCreator"
import { ReduxAction } from "../../../reducers"
import { Channel } from "../../../rpcs/dist/ChannelRPC"
import { Episode } from "../../../rpcs/dist/EpisodeRPC"
import { User } from "../../../rpcs/dist/UserRPC"

export class ActionDispatcher {
  constructor(private dispatch: (action: ReduxAction) => void) {}

  public fetchEpisodeData(episode: Episode) {
    this.dispatch(fetchEpisodeData(episode))
  }

  public fetchChannelData(channels: Channel[]) {
    this.dispatch(fetchChannelData(channels))
  }

  public updateTitle(title: string) {
    this.dispatch(updateTitle(title))
  }

  public updateAnonymousUser(user: User) {
    this.dispatch(updateAnonymousUserProfileImage(user))
  }

  public addTag(tag: string) {
    this.dispatch(addTag(tag))
  }

  public removeTag(tag: string) {
    this.dispatch(removeTag(tag))
  }

  public selectPostAccount(postAccount: Channel["id"] | null) {
    this.dispatch(selectPostAccount(postAccount))
  }

  public closeSurveyModal() {
    this.dispatch(closeSurveyModal())
  }

  public leaveThePage() {
    this.dispatch(leaveThePage())
  }

  public sending() {
    this.dispatch(sending())
  }

  public sendingFailed() {
    this.dispatch(sendingFailed())
  }
}
